import { useSyncExternalStore } from 'react';

const KEY = 'hc-privacy-blur';
const CHANGED = 'hc-privacy-blur-changed';

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

function subscribe(onChange: () => void) {
  window.addEventListener(CHANGED, onChange);
  window.addEventListener('storage', onChange); // other tabs
  return () => {
    window.removeEventListener(CHANGED, onChange);
    window.removeEventListener('storage', onChange);
  };
}

/**
 * Hidden personal data: names, e-mail addresses and phone numbers (marked with `pii`) are blurred on screen – e.g. while
 * sharing the screen or showing the application. Kept in this browser only; the data itself is still loaded.
 */
export function usePrivacyBlur(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}

export function setPrivacyBlur(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Private mode or blocked storage: the setting lasts until the page is reloaded.
  }
  window.dispatchEvent(new Event(CHANGED));
}
